<template>
  <tr :header="`${itemdescription} | ${person}`">
    <td>{{ itemdescription }} | {{ person }}</td>
    <td
      :class="{
        'text-danger': product.l_IC_F !== 'OK',
        'text-success': product.l_IC_F === 'OK',
      }"
    >
      {{ product.l_IC_F }}
    </td>
    <td>
      <form-element
        v-if="product.lfc !== false"
        v-model="product.lfc"
        :form-element="{
          type: 'select',
          name: 'productLeft',
          options,
          placeholder: $t('productLeft'),
          hideLabel: true,
          required: true,
          selectLabel: 'key',
          size: 12,
        }"
        @input="handleProductStatusChange($event)"
      />
    </td>
    <td
      :class="{
        'text-danger': product.r_IC_F !== 'OK',
        'text-success': product.r_IC_F === 'OK',
      }"
    >
      {{ product.r_IC_F }}
    </td>
    <td>
      <form-element
        v-if="product.rfc !== false"
        v-model="product.rfc"
        :form-element="{
          type: 'select',
          name: 'productRight',
          options,
          placeholder: $t('productRight'),
          hideLabel: true,
          required: true,
          selectLabel: 'key',
          size: 12,
        }"
        @input="handleProductStatusChange($event)"
      />
    </td>
    <td>
      <form-element
        v-if="product.itemID === '10000' || product.itemID === '10115'"
        v-model="product.r_Attenuation"
        :form-element="{
          type: 'select',
          name: 'attenuation',
          options: attenuationOptions,
          placeholder: $t('attenuation'),
          hideLabel: true,
          required: true,
          selectLabel: 'label',
          size: 12,
        }"
      />
      <div v-else class="text-center">N/A</div>
    </td>
    <td>
      <b-form-checkbox
        v-model="product.repair"
        name="repair"
        :disabled="commentFieldRequired"
        :unchecked-value="false"
        :value="true"
      >
      </b-form-checkbox>
    </td>
    <td>
      <form-element
        v-if="product.lfc || product.rfc"
        v-model="product.comment"
        :form-element="{
          type: 'text',
          name: 'comment',
          options,
          placeholder: $t('comment'),
          hideLabel: true,
          required: commentFieldRequired,
          size: 12,
          maxLength: 178, // Max 200 minus the default text in case of repair. See the RepairProduct method in FunctionControlHandler.cs (App_Code).
        }"
      />
    </td>
  </tr>
</template>

<script>
import {BFormCheckbox} from "bootstrap-vue";
import FormElement from "../form/FormElement.vue";

export default {
  components: {
    FormElement,
    BFormCheckbox,
  },
  props: {
    functioncontrolmethod: {
      type: String,
      required: false,
      default: "",
    },
    productid: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    itemdescription: {
      type: String,
      required: true,
    },
    person: {
      type: String,
      required: false,
      default: function () {
        return "";
      },
    },
    options: {
      type: Array,
      required: true,
    },
    allowRepair: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      product: {
        lfc: null,
        rfc: null,
        repair: false,
        r_Attenuation: null,
      },
      attenuationOptions: [
        {label: this.$t("lowA24S21"), value: 0},
        {label: this.$t("mediumA28S26"), value: 1},
        {label: this.$t("highA32S32"), value: 2},
      ],
    };
  },
  computed: {
    productRight: function () {
      return this.product.rfc;
    },
    productLeft: function () {
      return this.product.lfc;
    },
    rejectedOptions: function () {
      return ["04", "02", "03"];
    },
    commentFieldRequired: function () {
      if (
        this.rejectedOptions.includes(this.productLeft) ||
        this.rejectedOptions.includes(this.productRight)
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    productRight: function () {
      this.$emit("input", this.product);
    },
    productLeft: function () {
      this.$emit("input", this.product);
    },
    functioncontrolmethod(functioncontrolmethod) {
      this.product.functionControlMethod = functioncontrolmethod;
    },
  },
  created() {
    this.product = this.value;
    this.product.functionControlMethod = this.functioncontrolmethod;
  },
  methods: {
    handleProductStatusChange() {      
      if (this.eitherProductRejected()) {
        
        this.product = {
          ...this.product,
          repair: true
        }
        return
      }
      
      this.product = {
        ...this.product,
        repair: false
      }
    },
    eitherProductRejected() {
      if (
        this.rejectedOptions.includes("0" + this.productLeft) ||
        this.rejectedOptions.includes("0" + this.productRight)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
